const AppError = (o, msg) => {
  if (window.console) {
    window.console.warn('AppError: ' + msg, o);
  }
};

export default AppError;
